import { render } from "./EditExchangeView.vue?vue&type=template&id=4e892f5c"
import script from "./EditExchangeView.vue?vue&type=script&lang=js"
export * from "./EditExchangeView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__